import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { updateSelectedUserRoleByOrganizationId } from './user-info.actions';

@Injectable({ providedIn: 'root' })
export class UserInfoEffects {
  static readonly SELECTED_ORG_KEY = 'tcmr_selected_organization_id';

  saveSelectedOrganizationId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateSelectedUserRoleByOrganizationId),
        tap(({ organizationId }) => {
          this.saveSelectedOrganizationId(organizationId);
        }),
      ),
    { dispatch: false },
  );

  constructor(private readonly actions$: Actions) {}

  private saveSelectedOrganizationId(organizationId: string): void {
    try {
      localStorage.setItem(UserInfoEffects.SELECTED_ORG_KEY, organizationId);
    } catch (error) {
      console.error(
        'Failed to save selected organization to localStorage:',
        error,
      );
    }
  }
}
